"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainOrder = mapToDomainOrder;
exports.mapToDomainOrderDetail = mapToDomainOrderDetail;
exports.mapPreauthAdjustment = mapPreauthAdjustment;
exports.mapToDomainCheckOrdersList = mapToDomainCheckOrdersList;
function mapToDomainOrder(dto) {
    return {
        id: dto.id,
        clubId: dto.clubId,
        clubName: dto.clubName,
        machineId: dto.machineId,
        machineName: dto.machineName,
        orderStartTs: dto.orderStartTs,
        operationId: dto.operationId,
        amountPaid: dto.amountPaid,
        invoiceId: dto.invoiceId,
        //invoiceNumber: dto.invoiceNumber,
        invoiceType: dto.invoiceType,
        recapitulativeInvoiceId: dto.recapitulativeInvoiceId,
        recapitulativeInvoiceNumber: dto.recapitulativeInvoiceNumber,
        taxedAmount: dto.taxedAmount,
        totalVatAmount: dto.totalVatAmount,
        rateAmount: dto.rateAmount,
        exceedsPreauthLimit: dto.exceedsPreauthLimit ?? false,
    };
}
function mapToDomainOrderDetail(dto) {
    return {
        id: dto.id,
        clubId: dto.clubId,
        clubName: dto.clubName,
        machineId: dto.machineId,
        machineName: dto.machineName,
        orderStartTs: dto.orderStartTs,
        operationId: dto.operationId,
        amountPaid: dto.amountPaid,
        invoiceId: dto.invoiceId,
        //invoiceNumber: dto.invoiceNumber,
        invoiceType: dto.invoiceType,
        recapitulativeInvoiceId: dto.recapitulativeInvoiceId,
        recapitulativeInvoiceNumber: dto.recapitulativeInvoiceNumber,
        rateAmount: dto.rateAmount,
        exceedsPreauthLimit: dto.exceedsPreauthLimit ?? false,
        orderItems: dto.orderItems.map((item) => ({
            aisleCode: item.aisleCode,
            aisleName: item.aisleName,
            imgUrl: item.imgUrl,
            thumbnailUrl: item.thumbnailUrl,
            productName: item.productName,
            price: item.price ?? 0,
            amount: item.amount,
            payAmount: item.payAmount ?? 0,
            category: item.category,
            currency: item.currency,
            isReturn: item.isReturn,
        })),
        vatDetails: dto.vatDetails.map((vat) => ({
            vatPercent: vat.vatPercent,
            taxBase: vat.taxBase,
            vatAmount: vat.vatAmount,
        })),
        totalTaxBase: dto.totalTaxBase,
        totalVatAmount: dto.totalVatAmount,
        taxedAmount: dto.taxedAmount,
        ratePercent: dto.ratePercent,
        orderEndTs: dto.orderEndTs,
        billingVerificationSystem: dto.billingVerificationSystem,
        returnHistory: (dto.returnHistory ?? []).map((entry) => ({
            user: entry.user,
            customer: entry.customer,
            total: entry.total,
            date: entry.date,
        })),
        preauthAdjustment: mapPreauthAdjustment(dto.preauthAdjustment),
    };
}
function mapPreauthAdjustment(dto) {
    if (!dto)
        return null;
    return {
        originalAmount: dto.originalAmount,
        preauthLimit: dto.preauthLimit,
        chargedAmount: dto.chargedAmount,
        adjustmentAmount: dto.adjustmentAmount,
        vatBreakdown: (dto.vatBreakdown ?? []).map((row) => ({
            vatPercent: row.vatPercent,
            originalTaxBase: row.originalTaxBase,
            originalVatAmount: row.originalVatAmount,
            taxBaseAdjustment: row.taxBaseAdjustment,
            vatAmountAdjustment: row.vatAmountAdjustment,
            totalAdjustment: row.totalAdjustment,
        })),
    };
}
function mapToDomainCheckOrdersList(dto) {
    return {
        operationId: dto.operationId,
        orderStartTs: dto.orderStartTs,
        taxedAmount: dto.taxedAmount,
        deviceCode: dto.deviceCode,
        deviceName: dto.deviceName,
        micronClubId: dto.micronClubId,
        clubName: dto.clubName,
    };
}
